import React, {useState} from 'react';
import {Link, NavLink} from 'react-router-dom';
import {menu} from '../../menu/menu';
import styles from './HeaderMobileMenu.module.css';

import Logo from '../../assets/img/logo3.png';

import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { Box } from '@mui/material';


const IconComponent = ({iconName}) => {
    switch(iconName) {
        case "BusinessRoundedIcon":
            return <BusinessRoundedIcon/>
        case "BusinessCenterRoundedIcon":
            return <BusinessCenterRoundedIcon/>
        default:
            return null
    }
}

const HeaderMobileMenu = (props) => {

    const [expandedMenuId, setExpandedMenuId] = useState(props.expandedId ? props.expandedId : null);

    const menuTitleClickHandler = (menuid) => {
        props.expandedHanlder(menuid);
        expandedMenuId === menuid ? setExpandedMenuId(null) : setExpandedMenuId(menuid);
    }

    return (
    
        <div className={`${styles.mobileMenu} ${props.on ? styles.mobileMenuActive : ''}`}>
            <Box style={{marginBottom: '2rem'}}>
                <img src={Logo} alt="logo3.png" style={{width:'100%'}}/>
            </Box>
            <ul className={styles.mobileMenuList}>
                <li>
                    <NavLink 
                        to="/"
                        style={({isActive}) => ({color: isActive ? '#6e54f1' : ''})}
                        onClick={props.on}
                        className={styles.mobileMenuTitle}
                    >
                        <HomeRoundedIcon/>
                        HOME
                        <div style={{width: '24px'}}></div>
                    </NavLink>
                </li>

            {menu.map( (mobileMenu) => (
                <li key={mobileMenu.id} 
                    className={`${expandedMenuId === mobileMenu.id ? styles.mobileMainMenuActive : ''}`}
                    onClick={() => menuTitleClickHandler(mobileMenu.id) }
                >
                    
                    <Link to={mobileMenu.url}
                        className={
                            `
                            ${styles.mobileMenuTitle} 
                            ${expandedMenuId === mobileMenu.id ? styles.mobileMainMenuActive : ''}
                            `}
                    >
                        {mobileMenu.icon && <IconComponent iconName={mobileMenu.icon} />}
                        {mobileMenu.title}
                        
                        {mobileMenu.submenu.length ? 
                        <div>
                            {expandedMenuId === mobileMenu.id ? <KeyboardArrowUpRoundedIcon/> : <KeyboardArrowDownRoundedIcon />}
                        </div>
                        : null
                        }
                    </Link>

                        {mobileMenu.submenu.length ?
                        <ul className={`${styles.mobileMenuSubArea} ${expandedMenuId === mobileMenu.id ? styles.mobileSubMenuActive : null}`}>
                            {mobileMenu.submenu.map( (mSubMenu, mIndex) => (
                                <li key={mIndex}>
                                    <NavLink 
                                        to={mSubMenu.url} 
                                        className={styles.mobileMenuSubTitle} 
                                        style={({isActive}) => ({color: isActive ? '#6e54f1' : ''})}
                                        onClick={props.on}
                                    >
                                        {mSubMenu.subtitle}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                        : null
                        }

                </li>
            ) )}
            </ul>
        </div>


    )
}

export default HeaderMobileMenu;